import { API } from "../_services/api";
import { ActionKeys } from "../_actions/constants/userConstants";

export const actionCreators = {
  getUserInfo: () => async (dispatch, getState) => {
    //const token = getState()?.oidc?.user?.access_token; We will get the user token from state when we implement Auth0
    dispatch({ type: ActionKeys.REQUEST_USER_INFO });
    return dispatch(API.user.getUserInfo()).then(response => {
      if (response.error?.response?.status === 401) {
        window.location.href = "/401";
      }
      dispatch({
        type: ActionKeys.RECEIVE_USER_INFO,
        isError: response.isError,
        user: response.item,
        errorMessage: response.errorMessage
      });
    });
  }
};
